import {Action, createReducer} from '@ngrx/store';
import {WelfyMenuItem} from '@core/class/menu/welfy-menu-item';
import {environment} from '../../../environments/environment';

export interface SideMenuState {
  menu: Array<WelfyMenuItem>
  topMenu: Array<WelfyMenuItem>
}

export const initialState: SideMenuState = {
  menu: [
    {
      title: 'Bacheca',
      link: 'bulletin',
      icon: 'bookmark-outline',
      hidden: true
    },
    {
      title: 'Clienti',
      icon: 'people-outline',
      link: 'customers',
      home: true,
      hidden: true
    },
    {
      title: 'Reminders',
      link: 'reminders',
      icon: 'clock-outline',
      hidden: true
    },
    {
      title: 'Comunicazioni',
      icon: 'message-circle-outline',
      expanded: true,
      link: 'communications',
      hidden: true
    },
    {
      title: 'Simulazioni',
      icon: 'pie-chart-outline',
      expanded: true,
      children: [
        {
          title: 'Welfy Famiglia',
          expanded: true,
          children: [
            {
              title: 'Nuova Simulazione',
              link: 'simulations/family/newsim',
              icon: 'plus-outline',
            },
            {
              title: 'Carica Simulazione',
              link: 'simulations/family/load',
              icon: 'folder-outline',
            },
          ],
        },
        {
          title: 'Business',
          expanded: false,
          children: [
            {
              title: 'Nuova Simulazione',
              link: 'simulations/business/simulation',
              icon: 'plus-outline',
            },
            {
              title: 'Carica Simulazione',
              link: 'simulations/business/load',
              icon: 'folder-outline',
            },
            {
              title: 'Documenti',
              link: 'simulations/business/docs',
              icon: 'folder-outline',
            },
          ],
        },
        {
          title: 'Light',
          expanded: false,
          children: [
            {
              title: 'Nuova Simulazione',
              link: 'simulations/light/sim',
              icon: 'plus-outline',
            },
            {
              title: 'Carica Simulazione',
              link: 'simulations/light/load',
              icon: 'folder-outline',
            }
          ],
        },
        {
          title: 'Welfy Business',
          hidden: true,
          children: [
            {
              title: 'Nuova Simulazione',
              link: 'simulations/business/simulation',
              icon: 'plus-outline',
            },
            {
              title: 'Carica Simulazione',
              link: 'simulations/business/load',
              icon: 'folder-outline',
            },
            {
              title: 'Documenti',
              link: 'simulations/business/docs',
              icon: 'file-text-outline',
            },
          ],
        },
        {
          title: 'Welfy Light',
          hidden: true,
          link: 'simulations/light',
        },
      ],
    },
    {
      title: 'Utenti',
      icon: 'award-outline',
      link: 'collaborators',
    },
    {
      title: 'Uffici',
      icon: 'pin-outline',
      link: 'offices',
      hidden: true
    },

  ],
  topMenu: [
    {
      title: 'Hai bisogno di auto?',
      url: 'mailto:' + environment.support + '?Subject=Richiesta di assistenza Welfy',
      hidden: true
    },
    {
      title: 'Profilo',
      hidden: true
    },
    {
      title: 'Logout',
    },
  ]
}

const sideMenuReducer = createReducer(
  initialState,
);

export function reducer(state: SideMenuState | undefined, action: Action) {
  return sideMenuReducer(state, action);
}
